import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountComponent as AccountComponent } from './account.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RequestPasswordComponent } from './request-password/request-password.component';
import { LogoutComponent } from './logout/logout.component';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { RegistrationCompletedComponent } from './register/registration-completed/registration.completed.component';
import { ChangePasswordComponent } from './request-password/change-password/change-password.component';


export const routes: Routes = [
  {
    path: '',
    component: AccountComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'register',
        component: RegisterComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'request-password',
        component: RequestPasswordComponent,
      },
      {
        path: 'registration-completed/:email',
        component: RegistrationCompletedComponent,
      },
      {
        path: 'verify-account',
        component: VerifyAccountComponent,
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      },
    ],
  }
]

// {
//   path: 'auth-guard.service',
//   canActivate: [AuthGuard],
//   component: AuthPlaygroundComponent,
// },  

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {
}
